window.Mail = {

	prepareFilterForm: function(){
        var options = {
			data	: {
				action	: 'updateListing'
			},
			success	: function(data){
				Mail.processFilterForm(data);
			},
			dataType: "json"
		};
        MyForm.prepare("mailsFilterForm", "mailing_mail", options);
    },

	processFilterForm: function(data){
		Listing.refresh("mailsListing", data, data.mails_metadatas);
	},

	buildPagenum: function(pagenum, nbpage){},

	edit : function(linkedtype, linkedid, context, id){

		var mailid = id === undefined ? "" : id;
		var formid = "mailForm";

		var options = {
            title	: mailid === '' ? Loc.g("Nouveau courrier") : Loc.g("Modification du courrier"),
            buttons	: [
                {
					text	: Loc.g("Annuler"),
					'class' : 'btn btn-default',
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"),
                    'class' : 'btn btn-primary',
					click	: function(){
						$("#"+formid).submit();
					}
				}
			],
			width:850,
            callback	: function(){Mail.prepareEditForm(formid);}
        };
        MyWindow.load("mailing_mail", {action:"formMail", mid: mailid, linkedtype: linkedtype, linkedid : linkedid, context : context}, options);

	},

	prepareEditForm : function(formid){

		var options = {
			data	: {
				action:'recordMail'
			},
			success : function(data){
				Mail.recordCallback(data);
			},
			dataType:"json"
		};

		MyForm.prepare(formid, "mailing_mail", options, true);
		MyFacture.customForm();
		DocFormv2.changeAddress();

	},

	recordCallback : function(data){

		var formIsOk = MyForm.processJson(data, "mailForm");

		if (formIsOk) {

			Mail.getOverview(data.mailid);

		} else if(data.form.msg !== '') {

			MyWindow.alert(data.form.msg, {type: "error"});

		}

	},

	recordDocMailCallback : function(data){

		var formIsOk = MyForm.processJson(data, "sendMailForm");

		if (formIsOk){
			MyWindow.close();

			var alertOpts = {
				type	: 'confirm',
				modal	: true,
				buttons	: [{
					text	: Loc.g('Fermer'),
					click	: function(){
						// remove "afterRecording" url parameters before reloading
						window.location.href = window.location.href.replace(/&?afterRecording=([^&]$|[^&]*)/i, "");
					}
				}]
			};

			MyWindow.alert(Loc.g('Le courrier a bien été envoyé'), alertOpts);

		} else if(data.form.msg_type !== ''){

			Mail.showAlert(data.form.msg_type);

		} else if(data.form.msg !== ''){

			MyWindow.alert(data.form.msg, {type: "error"});

		}

	},

	showAlert : function(msg_type){
		var title	= '';
		var msg		= '';

		switch (msg_type){
		    case 'pdf_broken':

				$('#sendMailSubmit').addClass('btn-disabled').attr('disabled', 'disabled');

				title 	= Loc.g("Erreur lors de l'ajout du PDF");
				msg 	= Loc.g("Une erreur est survenue lors de l'ajout de votre PDF, si le problème persiste nous vous invitons à contacter notre service support")+".";

		        break;
		}

		if(msg !== '' && title !== ''){
			MyWindow.alert(msg, {type: 'error', title: title});
		}
	},

	sendDoc : function(linkedid, linkedtype, hasAddress){

		if(hasAddress === undefined){
			hasAddress = 'Y';
		}

		if(hasAddress === 'N'){
			MyWindow.alert(Loc.g("Votre document ne dispose pas d'adresse. Editez-le pour en ajouter une."), {type : 'warning'});
		} else {

			var formid	= "mailSendForm";
			var options = {
				dialogClass : "white",
				title		: Loc.g("Envoi par courrier postal"),
				buttons		: [
                    {
						text 	: Loc.g("Annuler"),
						click 	: function(){ $(this).dialog("close"); }
					},
                    {
						text	: Loc.g("Envoyer"),
						id		:" sendMailSubmit",
						click	: function() {
							$("#"+formid).submit();
							MyWindow.disable();
						}
					}
				],
				callback : function(){
					Mail.initPriceEngine();
					$('#mailSendForm :checkbox:first').trigger('change');

					if($('#mailSendForm input[name=sendable]').val() === 'N'){

						$('#mailSendForm').off('submit').on('submit', function(){
							Mail.incompleteAddresses(); return false;
						});

					}
					MyFacture.customForm();
				}
			};
			MyWindow.load("mailing_mail", {action:"docMailForm", linkedid:linkedid, linkedtype:linkedtype}, options);
		}

	},

	getOverview : function(mailid){

		var options = {
			title		: Loc.g("Aperçu de votre courrier"),
			buttons		: [
				{
					text : Loc.g("Fermer"),
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			width		: 1100,
			callback	: function(){Mail.initOverview();}
		};
		MyWindow.load("mailing_mail", {action:"overviewMail", mid: mailid}, options);

	},

	initOverview : function(){

		var buttons = [];

		$.each($('.mailActions a'), function(){

			var oncClick	= $(this).attr('onclick');
			var tmpBtn		= {
				html	: $(this).find('span').html(),
				'class'	: $(this).attr('class'),
				click	: function(){
					eval(oncClick);
				}
			};

			buttons.push(tmpBtn);
		});

		MyWindow.addOption('buttons',buttons);

		Mail.initPriceEngine();
		$('#mailSendForm :checkbox:first').trigger('change');
		MyFacture.customForm();

	},

	initPriceEngine : function(){

		$('#mailSendForm :checkbox, #mailSendForm select').off('change').on('change', function(){
			Mail.computePrice();
		});

	},

	computePrice : function(item){

		var qs = new Array();

		$('#mailSendForm :checkbox').each(function(){
			qs.push($(this).attr('name')+"="+($(this).prop('checked') ? 'Y' : 'N'));
		});
		$('#mailSendForm select').each(function(){
			qs.push($(this).attr('name')+"="+$(this).val());
		});

		qs.push("attachments="+$("#ms_attachment").val());

		$.post(
			'./?_f=mailing_mail&'+qs.join('&'),
			{
				action	: 'computeMailPrice',
				nbpages : $('input[name=ms_nbpages]').val()
			},
			function(data){

				if(data.pricing.error) {
					Mail.showAlert('pdf_broken');
				} else {

					$('#sendMailSubmit').removeClass('btn-disabled').removeAttr('disabled', '');

					$('#mailSendForm .totalAmount').html(data.pricing.formattedAmount);
					$('#mailSendForm .newCredit').html(data.credit.formattedNewQt);

					if(parseFloat(data.credit.newQt, 10) < 0){
						$('#mailSendForm .newCredit').parent().addClass('warning');

						$('#mailSendForm').off('submit').on('submit', function(){
							Mail.notEnoughCredit();
							return false;
						});

					} else if($('#mailSendForm input[name=sendable]').val() === 'N'){

						$('#mailSendForm').off('submit').on('submit', function(){
							Mail.incompleteAddresses();
							return false;
						});

					} else {

						$('#recapMail tbody').empty();
						for(var i = 0; i < data.pricing.lines.length; i++){
							var line = data.pricing.lines[i];

							if(line.option === 'N'){
								$('#recapMail tbody').append('<tr>'
									+'<td>'+line.label+'</td>'
									+'<td class="price">'+line.amount+'</td>'
									+'</tr>');
							}else{
								$('#recapMail tbody').append('<tr>'
									+'<td><input type="checkbox" id="opt_'+line.offer+'" name="opt['+line.offer+']" '+(line.active === 'Y' ? 'checked="true"' : '')+' value="Y" ><label for="opt_'+line.offer+'">'+line.label+'</label></td>'
									+'<td class="price">'+line.amount+'</td>'
									+'</tr>');
							}

						}

						$('#mailSendForm .totalAmount').html(data.pricing.formattedAmount);
						$('#mailSendForm .newCredit').html(data.credit.formattedNewQt);

						if(parseFloat(data.credit.newQt, 10) < 0){
							$('#mailSendForm .newCredit').parent().addClass('warning');

							$('#mailSendForm').off('submit').on('submit', function(){
								Mail.notEnoughCredit();
								return false;
							});

						} else if($('#mailSendForm input[name=sendable]').val() === 'N'){
							$('#mailSendForm').off('submit').on('submit', function(){
								Mail.incompleteAddresses();
								return false;
							});
						} else {

							$('#mailSendForm .newCredit').parent().removeClass('warning');
							$('#mailSendForm').unbind('submit');

							var options		= {};
							switch($('#mailSendForm input[name=action]').val()){
								case 'sendMail':
									options = {success : function(data){Mail.sendMailCallback(data);}, dataType:"json"};
									break;
								case 'sendDoc' :
									options = {success : function(data){Mail.recordDocMailCallback(data);}, dataType:"json"};
									break;

							}

							options.data = {
								action	: $('#mailSendForm input[name=action]').val()
							};

							MyForm.prepare("mailSendForm", "mailing_mail", options, true);
						}

						MyFacture.customForm("#recapMail");
						Mail.initPriceEngine();
						$('input[name=ms_amount]').val(data.pricing.amount);
					}
				}
			}, 'json');

	},

	notEnoughCredit :function(){
		MyWindow.alert(Loc.g("Vous n'avez pas assez de crédit pour envoyer ce courrier."), {type: "error"}); //+"\n"+Loc.g("Pour approvisionner votre compte, rendez-vous sur la page 'Courrier'")
	},

	incompleteAddresses :function(){
		MyWindow.alert(Loc.g("Envoi impossible : les adresses de l'expéditeur et/ou du destinataire sont incomplètes"), {type: "error"});
	},

	sendMailCallback : function(data){
		var formIsOk = MyForm.processJson(data, "mailSendForm");
        MyWindow.awake();

        if (data.error) {
            Push.error(data.error.message);
            return;
        }

		if(formIsOk){
			$('#mailSendForm .actualCredit').html($('#mailSendForm .newCredit').html());
			$('#mailSendForm :checkbox:first').trigger('change');
			MyWindow.alert("Votre message a bien été envoyé", {type: "confirm"});
			Listing.update('mailsListing', true);
		}else{
			MyWindow.alert(data.form.msg, {type: "error"});
		}
	},

	history : function(mailid){

        var options = {
            title	: Loc.g("Historique des envois"),
			width	: 900,
            buttons	: [
                {
					text	: Loc.g("Annuler"),
					'class' : 'btn btn-default',
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Retour"),
					'class' : 'btn btn-primary',
					click	: function(){
						Mail.getOverview(mailid);
					}
				}
			],
			callback : function(){
				Qtip.init();
			}
        };
        MyWindow.load("mailing_mail", {action:"historyMail", mid:mailid}, options);
	},

	refresh: function(mailid) {
		MyFacture.post(
			"mailing_mail",
			{
				action	: "refreshMail",
				mailid	: mailid
			},
			function(data){
				Listing.update('mailsListing', true);
				MyWindow.close();
			},
			"json"
		);
	},

	confirmDelete : function(mailid, id){

		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Supprimer le courrier"),
			buttons		: [
                {
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Supprimer"),
					click	: function(){
						Mail.doDelete(mailid);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Etes vous sur de vouloir supprimer ce courrier ?"), options);

	},

	cancelDelete : function(mailid, id){

		id = id !== undefined ? id : 'delete';
		$('#'+id+'-'+mailid).hide();

	},


	doDelete : function(mailid){

		MyFacture.post(
			"mailing_mail",
			{
				action	: "deleteMail",
				mailid	: mailid
			},
			function(data){
				Listing.update('mailsListing', true);
				MyWindow.close();
			},
			"json"
		);

	},

	changePreview: function(direction){

		var numPage			= parseInt($('.toolsPostal .num').html(), 10);
		var maxPage			= parseInt($('.toolsPostal .nb').html(), 10);
		var pictureWidth	= $('#postalPreview div.slide > .picture').width();

		if(direction === 'next' && numPage < maxPage){

			$('#postalPreview div.slide').animate({left:'-='+pictureWidth},300);
			$('.toolsPostal .num').html(numPage + 1);

		} else if (direction === 'previous' && 1 < numPage){

			$('#postalPreview div.slide').animate({left:'+='+pictureWidth},300);
			$('.toolsPostal .num').html(numPage-1);
		}

		Mail.updateTools();
	},

	changePreviewEnd: function(direction){

		var maxPage	= parseInt($('.toolsPostal .nb').html());
		var left	= parseInt($('#postalPreview div').css('left'));

		if(direction === 'next'){

			$('#postalPreview div.slide').animate({left:(-(maxPage-1)*600)}, 300);
			$('.toolsPostal .num').html(maxPage);

		} else if (direction === 'previous'){

			$('#postalPreview div.slide').animate({left:0}, 300);
			$('.toolsPostal .num').html(1);

		}

		Mail.updateTools();
	},

	updateTools: function(){

		var numPage	= parseInt($('.toolsPostal .num').html());
		var maxPage	= parseInt($('.toolsPostal .nb').html());

		if(maxPage>1){

			if(numPage === 1){
					$('.toolsPostal .previous, .toolsPostal .previousEnd').addClass('disabled');
					$('.toolsPostal .next, .toolsPostal .nextEnd').removeClass('disabled');
			} else if(1 < numPage && numPage < maxPage) {
					$('.toolsPostal .previous, .toolsPostal .previousEnd').removeClass('disabled');
					$('.toolsPostal .next, .toolsPostal .nextEnd').removeClass('disabled');
			} else if(maxPage === numPage){
					$('.toolsPostal .previous, .toolsPostal .previousEnd').removeClass('disabled');
					$('.toolsPostal .next, .toolsPostal .nextEnd').addClass('disabled');
			}
		} else {
			$('.toolsPostal .previous, .toolsPostal .previousEnd').addClass('disabled');
			$('.toolsPostal .next, .toolsPostal .nextEnd').addClass('disabled');
		}
	}
};
